// extracted by mini-css-extract-plugin
export var actions = "_mo-g";
export var benefitCard = "_mo-b";
export var benefitIcon = "_mo-d";
export var benefitLabel = "_mo-f";
export var benefits = "_mo-a";
export var benefitsSection = "_mo-8";
export var bodyText = "_mo-7";
export var closeButton = "_mo-2";
export var content = "_mo-3";
export var eyebrow = "_mo-4";
export var heading = "_mo-5";
export var image = "_mo-i";
export var imagePanel = "_mo-h";
export var modal = "_mo-0";
export var offerCard = "_mo-c";
export var offerIcon = "_mo-e";
export var sectionLabel = "_mo-9";
export var shell = "_mo-1";
export var title = "_mo-6";